import axios from 'axios';

export async function exportToCSV(dataToSend: any, type: 'reportCount' | 'usersManage') {
  let link: HTMLAnchorElement | null = null;
  
  try {
    const response = await axios.post(
      '/api/exportCsv',
      { data: dataToSend, type },
      {
        headers: {
          'Content-Type': 'application/json',
        },
        responseType: 'blob',
      },
    );

    const contentDisposition = response.headers['content-disposition'];
    let filename = 'export.csv';
    if (contentDisposition) {
      const filenameMatch = contentDisposition.match(/filename="?([^"]+)"?/);
      if (filenameMatch) {
        filename = filenameMatch[1];
      }
    }

    const url = window.URL.createObjectURL(new Blob([response.data]));
    link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    
    window.URL.revokeObjectURL(url);
    
  } catch (error) {
    console.error('Failed to export CSV:', error);
  } finally {
    if (link && link.parentNode) {
      link.parentNode.removeChild(link);
    }
  }
}
